import { Participant } from '../../models/participant.model';
import { SessionCancellationReason } from '../../models/session-cancellation-reason.enum';
import { Signing } from '../../models/signing.model';
import { ParticipantStatusUpdate, SigningStatusUpdate } from 'src/app/core/signalR/esign-hub.model';

export interface SessionState {
  participantId: string | null;
  participant: Participant | null;
  signing: Signing | null;
  sessionId: string | null;
  signingJoinCode: string | null;
  isLoading: boolean;
  error: string | null;
  currentDocumentIndex: number;
  signingStatusUpdates: Record<string, SigningStatusUpdate>;
  participantStatusUpdates: Record<string, ParticipantStatusUpdate>;
  sessionCancellationReason: SessionCancellationReason | null;
}

export const initialSessionState: SessionState = {
  participantId: null,
  participant: null,
  signing: null,
  sessionId: null,
  signingJoinCode: null,
  isLoading: false,
  error: null,
  currentDocumentIndex: 0,
  signingStatusUpdates: {},
  participantStatusUpdates: {},
  sessionCancellationReason: null,
};
